import { Box, Typography, type SxProps, type Theme } from "@mui/material";
import { forwardRef, type LiHTMLAttributes } from "react";
import type { BackendUser } from "types/interfaces/adminUsers";
import CustomScrollbars from "components/CustomScrollbars";
import { getBackendUserPrimaryLabel } from "utils/backendUserLabel";

export function BackendUserLabelBlock({ user }: { user: BackendUser }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 0.2,
        textAlign: "left",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        fontWeight={600}
        color="text.primary"
        lineHeight={1.3}
        sx={{ display: "block" }}
      >
        {getBackendUserPrimaryLabel(user)}
      </Typography>
      <Typography
        component="span"
        variant="caption"
        color="text.secondary"
        sx={{
          fontSize: "0.7rem",
          lineHeight: 1.25,
          fontWeight: 400,
        }}
      >
        @{user.username} · id {user.id}
      </Typography>
    </Box>
  );
}

export const backendUserAutocompleteComponentsProps: {
  paper: { elevation: number; sx: SxProps<Theme> };
} = {
  paper: {
    elevation: 0,
    sx: (theme: Theme) => ({
      boxShadow: theme.shadows[12],
      border: "1px solid",
      borderColor: "divider",
    }),
  },
};

export function renderBackendUserAutocompleteOption(
  props: LiHTMLAttributes<HTMLLIElement>,
  option: BackendUser,
) {
  return (
    <li {...props}>
      <Box sx={{ width: "100%", py: 0.4 }}>
        <BackendUserLabelBlock user={option} />
      </Box>
    </li>
  );
}

export const BackendUserAutocompleteListbox = forwardRef<
  HTMLUListElement,
  React.HTMLAttributes<HTMLUListElement>
>(function BackendUserAutocompleteListbox({ children, ...listboxProps }, ref) {
  return (
    <CustomScrollbars
      ref={ref}
      variant="compact"
      scrollableElement="ul"
      preserveScrollOnGrow
      scrollableProps={listboxProps}
      trackOffsetTop={10}
      trackOffsetBottom={10}
      sx={{ width: "100%", minWidth: 0 }}
    >
      {children}
    </CustomScrollbars>
  );
});
